
<template>

  <div v-title data-title="专题活动">
    <div class="search-bar" v-if="!issearch" style="background: #ee7310;">
      <div class="search-logo"><img src="../../assets/img/logo.png"/></div>
      

      <div class="input" @click="showsearch()">
        <i class="van-icon">
          <div class="van-image van-icon__image">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAYAAABxlTA0AAAAAXNSR0IArs4c6QAAC2ZJREFUeAHtnH9wXUUVx0n6wyQ0akmHSAQdnGnCj0EdqLWFMvLijxKLdJrY0iS1Fn8MoqiDHZmBRsepgw6VqgiDI/JPQ5OGhv6iTKkDtsEiVSijItbEUgvUtFq0NT/a5keT+DklD+7be959+27uS9593juzubtnd8+e833nnt09d2/OOSe6IgQiBCIEIgQiBCIEIgQiBLIQgbxskmnDhg1lw8PDFcg0My8v77yRkZFiSeTzufdw7+HelZ+ff3Dy5Mkdixcvfg3acDbpYMoyYQADVF5zc/OVAFQJqJUIdjXpnaaAKcp99N8Hr12AvgvQ9y5ZsmQgRZ9xrR53gAH1EgD5HGkZmr4vSG0B+zh8WwD6kaVLl/4uSN5+eY0bwABbifKrSGKtGb8A+yXG+kF9fX0r+QlzIxkHGL96LS7gHpSdm3FUlQEA92+M/d1ly5Y9qlRnnJQxgDdv3nz+qVOn1qDB59PQ4qQAQvsOQDlMvpvUS3mI8tkJj/wFpAroFdCmk7e9fj116tSv4aM7bDsE0S4jADc1NVUj3MOpAACkIdo9TbunJk2atAu/+Sdo1o9zS0tLOU9HjPQJ+HyaVERKesF7gLHuwprXJm0UcEWgAG/cuHHqwMDAvcj4dS85UbSd+oe4N9fV1f3Lq61t3bZt24p7e3trAPDL9JEVSdKLcbdPmTJlBdZ8PGmjgCoCAxirnY5yTyCXl3JioXcD6ibu1paarq5MqB9DlgaSWHay6xAyzGcSPJCsQRD0QADetGnThX19fTtR6HJNKBQ5Qbqztrb2l5kE1hybCXbB0NDQ/dAvNuukjCxvcKsC5Be1+iBoYwYYJS5CiWcRRl3TosSTpOVY7b+DEDhdHritwlG39VWtL7L14v8/mal185gAZqVQwkphD4JfqgnP7motVnsHSmTMHWjjajTcxi1MhmLNU8x65DsOyPMA+a9m3VjLvgEetYxdCDDHFAKB+0m3YLXrzLqJLI/65sdwZTNMOZD3MBPfXCa+TrNuLOV8v53PnDlzH31d4EI7huVWZhu4oicyPQOIswHzL1J2XoB+0eDgYMvu3bsnO+ljzfsCGEuo5XGT5ZB59REHuAG38JxZkS1lLPQQBvApQD5iygTI844ePbrapI+lnLaLGJ3UxAKKlYHrWcQ3K/SsI7FJ+QhP4W8QrMApHMCPkGJi7U6633zaFozl/pTBXOBiFT8MC7gCFhPaC9y+KHnnhRXnoeOD+/btc02Gzna2+bQAXr9+fRUCyDbYvB7HLTSYxGwvi0GIYShyXtbe3n67Qk+bZA2w/LJwl22wef2TIMpyHqsJX4qZgtmURw1Dix03yO7UhodXG2uA8b1iuZcpzFYycXQp9FCQxDBIt5Ik8OS8xA1+00nwk7cGGL90lzLAnjD5XUX+syS2yn8k85BS/w0JIil0a5IVwCzL5sHxSpMrv/pqkxbWsvhi9Blwyo9bnE6ETl5t+b6sAIb7cnMEhHmeX/5pkx7WMr74MLI3mvIDskt3s41XOSXAO3bseAfuYbHJBIBlX59TF/GIBxSF5jDZzVToVqSUAHd1dUlM9d1OboDbW1JSssVJy4X86BuVl0xd0LfGpNmWUwKM9X5cYbZl/vz5JxV66EmAud5UAjehYWA2U8spAaZXTOn5K4WWEyQMaqeiyDXyOkyhpyR5Aoz/lZM2HzK5FBQUSJgyJy8m7pexYnnT8daFBRcSt7jqLUIaGU+Au7u75dV4QkCIwQ/W1NQcTWOMUDVFvxEE/q0pNDhomyyzmavsCTCPixzEM6/Ao/7mAFlQ3m/KAMAaFmYzV9kT4CRM5ZV7rl+uwylYdrkfpT0BhqHr1Qqgv+pnoJD10XR0YWGjUyqAXftwfsluG8Yhb6Pp6MLCRkdPgLFWF1P27L02jMPchh1djym/hoXZRit7Aoy1uqL6nIEY1BjlEg0j0nR0YWGjsyfAMHBZK6BPs2Ec5jaseV1PLvr42rl6AsxjEdijEibAseDxARhQXM6ewc8PE1h+ZMWwNB1P+OHlacGA+XeTKYP7WnCbfLK5zAbLtebVsLDRIRXArgU3THMeYHS8xAQPwzpo0mzKngCzYtAAvsJvZMlGoGxoA5izFDl87WA9AeZ0y+usGrTI0lxFgJwgyYlRdP6gqUxhYeFek2ZT9gSYgSSy1GYywkdVmrRcKff398ew4IQIIrq9Ul1dfcyPjp4AC0MG02K/rnd0fgbPxj64RZduGJqGgZX4KQFm27hz1JKdDC/lIIrmp5xtQpdnbnkXQt+oCL5ZoVmRUgLM6+xXsWL5RCDhwk18IYGQAwXOB9ehhnna8kRFRUXmLFhwYw3YaOIH6Dfzi7/HpIe1LAev0enbivyNs2bN0mITSlM3KaUFSxcOVbdyM7fNBXxc8i03y3BSjhw5UovkFzulxzUO8P5RO/DobOaZtwJYDvcx2IMmJ2i3YcUJQpltwlDevn17EXJ+X5G1kfeP/1Do1iQrgIUb68AfA+hpJ2ceqUL81s+ctDDme3p65KPF9ztlR9chvue4x0nzk7cGWNaBCPGAOQi0GzhaVG/Sw1KW1RA6rFTkfZQn9xWFnhbJGmDhykHr1dw6zREQ8GH55sGkZ3uZL1QvYDW0DfkTDpVgvfIZmuYy0lYpLYD5RXsZWDtaX8ACfSvWUJa2BBPUgVVDAZ//bgVcTeY7CBP4ij2Y6qQFsHTm5IusKB4zGYmgWMMWEdysy8Yyqwb5dwuzTdkwoCcB936T7recNsAyEK7iSwiixYpnd3Z2rgvqCx2/SqXqx5zxPcDV5o1j6HUzSWIwgVxmUMOaKUJehZCyw9Mstq2oqOizTIz/sWY4Dg0lzMqq5xfIvUIbDmAX8ITu0Or80nxZsAyGIC8Sp6hDKPPjEam+7vTp08/z6cHlUsiGC1lK2RjtTgYuMvZRF/jHPL4BFtCIU2xBqFs1AKF/AJ+8F8U+o9WPJ42n7cPI8wJjXu0xbgHGspNvAa/xaJN2lW8X4RwJBW5DgfugaT+YfCb1c1xGw6JFi/7r7JfpvLgErHYl438H+QptxqNtL22v5+sp1wlLm/5mm0AAFqb88jchXCPCJawpHQPKV/irysvL140leOLg55mVJwdZ1pBc79c8O75ZKXGXqiBADgxgkYt18HW4hRaUKn1TTvWvvIb60bRp09YtXLjQDCCpHWyJsnrhE9hq2t9Jch0cd/CRfx/2B+Sc56AlZIOy5EABFgklhMlM3YTwlQkSuwunUGIr5KYZM2Y84/ebDwH1wIEDc/hhb2LMpfArcQ/1NoUxn2VyXlFaWvoaa+Fm+rjeYLzd+mwEcUyWHDjAIhxC5+OXb0cZWW/aHLUapO3v6Sp+r518ByHS17HynqqqKjm+NdLa2nouwBTz48n2Vk7eS/ooddeSziV5XvDsp0EDmwgJWg1LY4kBZxrkjAAc1xRrfi+A/AQgvKwk3jzpHUBg4XoRmbS9UrGHzdFX2OrvN+syDXJGAY4rI4EgYhWrKN84RqDiLFPe5Ueh0eNMrGtYTj7n1SGTII8LwHHlWGlcgeKybhZ/eV6cHuQd/uIKHiGWey8W22HLO1MgjyvAcWVlfYpFL8CXLgLoGPQL43V+7oAqa9enuG8F2CcA9rgfPrYgMxdcn+qpiI8/IQDHB4/fmRBnkpcdlKxZZfIq5y4WLv9evIgyt7OWeZL8G9APkSTY9Gcmw724gZcBVduy0yS9K2iQswJgLwgANL+trS0/Foud8WoXZF2QIGc9wEEClw6voECOAPZAPQiQteCMx5D/X1XilsrKyiQk2+qheTET9tpk9RHAyZAZpVuAvJ9I4cJkbCIXkQwZg57EXQi4Ma+jrRHABpBeRQPklOAKrwhgL0SVOgGZfyB6N2fW1npZrtI1IkUIRAhECEQIRAjkFgL/A1PVq74xX3+pAAAAAElFTkSuQmCC"
              class="van-image__img"
              style="object-fit: contain;"
            />
          </div>
        </i>
        <span class="placeholder" v-if="productName==''">搜索商品</span>
        <span class="placeholder" v-if="productName!=''">{{productName}}</span>
      </div>
      <div class="wrap">
        <div class="collect">
          <img
            v-if="formset.WechatLogoUrl!=''"
            :src="formset.WechatLogoUrl"
            width="40"
            style="border-radius: 50px;"
          />
          <img
            v-if="formset.WechatLogoUrl==''"
            src="../../assets/logo.png"
            width="40"
            style="border-radius: 50px;"
          />
        </div>
      </div>
    </div>

    <div class="my-search" v-if="issearch" style="background:#f3f3f3">
      <div class="search-top">
        <div class="van-search van-search--show-action" style="background:#ffffff;">
          <div class="van-search__content van-search__content--round">
            <div class="van-cell van-cell--borderless van-field">
              <div class="van-field__left-icon">
                <i class="van-icon">
                  <div class="van-image van-icon__image">
                    <img
                      src="data:image/png;base64,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"
                      class="van-image__img"
                      style="object-fit: contain;"
                    />
                  </div>
                  
                </i>
              </div>
              <div class="van-cell__value van-cell__value--alone">
                <div class="van-field__body">
                  <input
                    type="search"
                    v-model="productName"
                    placeholder="请输入搜索关键词"
                    class="van-field__control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="van-search__action">
            <div @click="issearch=false">
              <span v-if="productName!=''" @click="onSearch()">搜索</span>
              <span v-if="productName==''">取消</span>
            </div>
          </div>
        </div>
      </div>
      <div class="hot-search">
        <!---->
        <!---->
        <div class="search-tags"></div>
        <p class="search-title">热门搜索</p>
        <div class="search-tags">
          <span
            v-for="(s,$index) in this.hotsearchtag"
            :key="$index"
            @click="searchtags(s)"
            class="van-tag van-tag--round van-tag--default"
            style="background-color: rgb(233, 233, 233); color: rgb(90, 90, 90);"
          >{{s}}</span>
        </div>
         </div>
    </div>
    <div v-if="!issearch" class="sp_containerspecialeventc sp_container ">
      <div class="nav-title" v-if="false">
        <span 
          :class="activeEventName==event.ActivityName?'nav-tab active':'nav-tab'"
          v-for="(event,$index) in events"
          :key="$index"
          @click="chooseActiveEvent(event)"
        >{{event.ActivityName}}</span>
      </div>

      <div class="productcontent" v-html="Content"></div>

      <!--生成海报-->
      <div @click="generateActivityPoster()" class="generateposters" v-if="userType==4">
        <img src="../../assets/img/generate.png" />
      </div>
      <!--生成海报-->
      <div v-if="this.activeEventName.indexOf('西沙')>=0" @click="StartDraw()" class="generateposters" style="top: 260px;">
        <img src="../../assets/img/youhuiquan.png" />
      </div>
      <!-- 海报图-->
      <wv-popup :visible.sync="popupVisiblediy" height="100%">
        <scroller style="position:fixed;top:0;text-align:center;">
          <img
            v-if="popupVisiblediy"
            v-bind:src="'data:image/png;base64,'+base64"
            style="width:70%; margin-top:20px;"
          />
          <div style="text-align:center;color:black;font-size:16px">长按海报保存到手机或者发送</div>
          <div style="text-align:center;" @click="popupVisiblediy=false">
            <i data-v-460a00e2 class="weui-icon-cancel"></i>
          </div>
        </scroller>
      </wv-popup>
      <div style="margin-top:20px">
        <div
          v-for="(item,$index) in formset.List"
          :class="formset.List.length>=($index)*2+1? 'weui-flex rmcp':''"
          :key="$index"
        >
          <div
            v-if="formset.List.length>=($index)*2+1"
            class="weui-flex__item"
            @click="ProductDetail(formset.List[(($index)*2)].Guid)"
          >
            <img
              v-lazy="formset.List[($index)*2].ProductImgUrl"
              class="lazy-img-fadein"
              :key="formset.List[(($index)*2)].ProductImgUrl"
            />
            <a href="javascript:void(0)">{{formset.List[($index)*2].ProductName}}</a>
            <p class="fc-red">
              ￥
              <i>{{formset.List[($index)*2].SatrtAmount}}</i>
              <span v-if="userType==4">赚￥{{formset.List[($index)*2].Commission}}</span>
              <span v-else class="order">立即预定</span>
            </p>
          </div>
          <div
            v-if="formset.List.length>=($index)*2+2"
            class="weui-flex__item"
            @click="ProductDetail(formset.List[(($index)*2+1)].Guid)"
          >
            <img
              v-lazy="formset.List[(($index)*2+1)].ProductImgUrl"
              class="lazy-img-fadein"
              :key="formset.List[(($index)*2+1)].ProductImgUrl"
            />
            <a href="javascript:void(0)">{{formset.List[(($index)*2+1)].ProductName}}</a>
            <p class="fc-red">
              ￥
              <i>{{formset.List[(($index)*2+1)].SatrtAmount}}</i>
              <span v-if="userType==4">赚￥{{formset.List[(($index)*2+1)].Commission}}</span>
              <span v-else class="order">立即预定</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import wx from "weixin-js-sdk";
import { debug } from "util";
export default {
  name: "specialevent",
  data: function() {
    return {
      activeEventName: "",
      events: [],
      formset: { List: [] },
      popupVisiblediy: false,
      userType: -1,
      base64: "",
      disid: "",
      Content: "",
      activeGuid: "", //专题活动guid
      productName: "",
      hotsearchtag: ["摩飞", "大宇", "北鼎", "法格", "BRUNO", "海氏", "康巴赫", "卡特马克", "科西"],
      issearch: false
    };
  },
  created: function() {
                //debugger;
    var disid = this.$route.query.disid;
    if (disid != undefined && disid != null && disid.length > 0) {
      this.disid = disid;
      localStorage.setItem("disid", disid);
    }
    var activeGuid = this.$route.query.activeGuid;
    if (
      activeGuid != undefined &&
      activeGuid != null &&
      activeGuid.length > 0
    ) {
      this.activeGuid = activeGuid;
    }
    this.initActivity();
  },
  methods: {
    initActivity: function() {
                //debugger;
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbactivity/gettbactivitys", {
          params: {
            activityType: 1,
            disid: this.disid
          }
        })
        .then(
          function(d) {
                //debugger;
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.events = rep.Data;
              if (rep.Data != null && rep.Data.length > 0) {
                if (
                  this.activeGuid != undefined &&
                  this.activeGuid != null &&
                  this.activeGuid != ""
                ) {
                  //定位到目标专题活动
                  var isExist = 0;
                  for (var i = 0; i < rep.Data.length; i++) {
                    if (
                      rep.Data[i].Guid.toString() == this.activeGuid.toString()
                    ) {
                      this.chooseActiveEvent(rep.Data[i]);
                      document.title = rep.Data[i].ActivityName;
                      isExist = 1;
                      break;
                    }
                  }
                  //定位的专题活动已下架，默认显示第一个专题活动
                  if (isExist == 0) {
                    this.chooseActiveEvent(rep.Data[0]);
                      document.title = rep.Data[i].ActivityName;
                  }
                } else {
                  //默认显示第一个专题活动
                  this.chooseActiveEvent(rep.Data[0]);
                      document.title = rep.Data[i].ActivityName;
                }
              } else {
                //debugger;
                //没有任何专题活动，显示默认页面
                this.$router.push("/page/nospecialevent");
              }
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {}
        );
    },
    StartDraw: function () {
      //调用接口获得奖品信息，根据奖品判断是否需要弹出礼品邮寄地址div
      if (this.drawID != "") {
        this.$http
          .get(
            this.GLOBAL.BASE_URL + "api/draw/startdraw?id=" + this.drawID,
            {}
          )
          .then(function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.response = rep.Data;
              if (this.response.PrizeID == -1) {
                Toast.fail(this.response.PrizeName);
              } else {
                Toast.success(this.response.PrizeName);
                this.flag = true;
              }
            } else {
              Toast.fail(rep.Message);
            }
          });
      }
    },
    chooseActiveEvent: function(event) {
      this.activeGuid = event.Guid;
      this.activeEventName = event.ActivityName;
      this.Content = event.Content;
      var flag = this.activeEventName.indexOf("西沙")>=0;
      if(flag)
      {
        this.drawID="1413016068649259008";
        //this.StartDraw();
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbproduct/getactivityproducts", {
          params: {
            activityGuid: event.Guid
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
              this.disid = rep.Data.DisGuid;

              var i = 0;
              for (; i < this.formset.List.length; i++) {
                if (this.formset.List[i].ProductName.length > 20) {
                  this.formset.List[i].ProductName =
                    this.formset.List[i].ProductName.substring(0, 20) + "...";
                }
              }
              this.userType = rep.Data.LoginType;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {}
        );
    },
    //生成活动海报
    generateActivityPoster: function() {
      this.$store.commit("showLoading");
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbproduct/generateactivityposter", {
          params: {
            activityGuid: this.activeGuid,
            isMiniProgram: (window.__wxjs_environment == 'miniprogram'?1:0)
          }
        })
        .then(
          function(d) {
            this.$store.commit("hideLoading");
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.base64 = rep.Data;
              this.popupVisiblediy = true;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {}
        );
    },
    //产品详情
    ProductDetail: function(orderGuid) {
      if (this.LoginType == 4) {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid,
            disid: this.disid
          }
        });
      } else {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid
          }
        });
      }
    },
    onSearch(val) {
      this.$router.push({
        path: "/page/mustpushtoday",
        query: {
          keyword: encodeURI(this.productName)
        }
      });
    },
    showsearch: function() {
      this.issearch = !this.issearch;
    },
    searchtags: function(v) {
      this.productName = v;
      this.showsearch();
      this.onSearch();
    }
  }
};
</script>

<style>
.sp_container {
  margin: 0;
  padding: 0;
  min-height: 600px;
}
.sp_containerspecialeventc{
  padding-top: 58px;
  padding-bottom: 50px;
}
.nav-title {
  padding: 10px 5px;
  font-size: 14px;
}
.nav-tab {
  display: inline-block;
  padding: 2px 10px;
  border: #cccccc solid 1px;
  background: #fff;
  border-radius: 50px;
  margin-left: 5px;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  -ms-border-radius: 50px;
  -o-border-radius: 50px;
}
.nav-tab.active {
  border: none;
  background: #fb772d;
  color: white;
}

.order {
  display: inline-block;
  width: 80px;
  height: 25px;
  line-height: 25px;
  background: #f98336;
  border-radius: 58px;
  text-align: center;
  color: #fff;
  float: right;
  margin: 0;
}

.weui-search-bar {
  z-index: 9999;
}

.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 2em;
  padding-top: 70px;
  font-size: 1.5rem;
}

.search_left {
  width: 50%;
  text-align: center;
  float: left;
  background-color: #fff;
}
</style>







// WEBPACK FOOTER //
// src/components/specialevent/specialevent.vue